import { render, staticRenderFns } from "./CustomCaptchaDialog.vue?vue&type=template&id=6145225a&scoped=true&"
import script from "./CustomCaptchaDialog.vue?vue&type=script&lang=js&"
export * from "./CustomCaptchaDialog.vue?vue&type=script&lang=js&"
import style0 from "./CustomCaptchaDialog.vue?vue&type=style&index=0&id=6145225a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6145225a",
  null
  
)

export default component.exports